import { render, staticRenderFns } from "./usermodul.vue?vue&type=template&id=ab65e634&scoped=true"
import script from "./usermodul.vue?vue&type=script&lang=js"
export * from "./usermodul.vue?vue&type=script&lang=js"
import style0 from "./usermodul.vue?vue&type=style&index=0&id=ab65e634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab65e634",
  null
  
)

export default component.exports